import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData } from "../../services/generalService";
import { PaymentTransactionObj } from "../../utils/types";

const initialState: PaymentTransactionObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getPaymentTransactionDetails = createAsyncThunk(
  "loans/getPaymentTransactionDetails",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

const paymentTransactionSlice = createSlice({
  name: "payment-transaction-details",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentTransactionDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPaymentTransactionDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getPaymentTransactionDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default paymentTransactionSlice.reducer;
